export default __webpack_public_path__ + "static/media/contact.d0190945.svg";